import { render, staticRenderFns } from "./AdminNbEdit.vue?vue&type=template&id=f7119eaa&scoped=true"
import script from "./AdminNbEdit.vue?vue&type=script&lang=js"
export * from "./AdminNbEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminNbEdit.vue?vue&type=style&index=0&id=f7119eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7119eaa",
  null
  
)

export default component.exports